import React, {JSX} from 'react';
import {BlockBase, ContentData, ContactPerson} from '../../interfaces.ts';
import {getContentValue, isBlockTypeCorrect} from '../../utils.ts';
import {useServerProvider} from "../../use-server-provider.tsx";

interface ContactBlockProperties {
  withHeader: boolean;
  headerLevel: number;
}

interface ContactBlockContentData {
  headerText: string;
}



const defaultContactPerson: ContactPerson = {
    firstName: 'John',
    lastName: 'Doe',
    function: 'Recruiter',
    postalAddress: {
        streetAddress: '123 Main St',
        addressLocality: 'Anytown',
        postalCode: '12345'
    },
    phoneNumber: '555-555-5555'
}

const ContactBlock: React.FC<{ block: BlockBase<ContactBlockProperties, ContactBlockContentData>, contentData?: ContentData<ContactBlockContentData> | null, editable?: boolean, locale: string, fallbackLocale: string, contactPerson?: ContactPerson }> = ({ block, contentData, editable = false, locale, fallbackLocale, contactPerson: contactPersonData }) => {
  const { id, properties } = block;
  const onContentChange = useServerProvider<(blockId: string, field: string, value: any) => void>('onContentChange')

  if (!isBlockTypeCorrect(block, 'contactBlock')) {
    return null
  }

  const contactPerson = contactPersonData ?? defaultContactPerson;

  const { headerText } = getContentValue(locale, fallbackLocale, block, contentData)

  if (!headerText) {
    return null;
  }

  const handleInput = (event: React.FormEvent) => {
      if (onContentChange) {
          onContentChange.value(id, 'headerText', (event.currentTarget as HTMLElement).innerHTML);
      }
  };

  const TagName = `h${properties.headerLevel}` as keyof JSX.IntrinsicElements;
  const headerBlock = <TagName key={id} onInput={handleInput} contentEditable={editable} suppressContentEditableWarning={true} data-block-id={id} data-field="headerText">{headerText}</TagName>;

  const postalAddressText = [contactPerson?.postalAddress?.streetAddress, contactPerson?.postalAddress?.postalCode, contactPerson?.postalAddress?.addressLocality]
    .filter(el => el)
    .join(' | ')
  ;

  return (
    <div id={id} key={id} data-block-id={id} className="contact-person">
        <div className="contact-person-image-wrap">
            <img src={contactPerson.image} alt="Name" />
        </div>
        <div className="contact-person-content">
            <div className="contact-person-header">
                {properties.withHeader && headerBlock}
            </div>
            <div className="contact-person-name">
                {contactPerson.firstName} {contactPerson.lastName}, <span>{contactPerson.function}</span><br />
            </div>
            <div className="contact-person-address">
            {postalAddressText}
            </div>
            <div className="contact-person-phone-number">
            T <a href={`tel:${contactPerson.phoneNumber}`}>{contactPerson.phoneNumber}</a>
            </div>
        </div>
    </div>
  )
};

export default ContactBlock;